import { catchError, of, switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getLinkModulesContent } from 'constants/routes';

function getLinkModulesContentRequest$(searchParameters) {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      searchCommand: {
        ...searchParameters,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  return fromFetch(getLinkModulesContent, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError(() => of(null))
  );
}

export default getLinkModulesContentRequest$;